import { forwardRef, type HTMLAttributes, type RefObject } from 'react';
import { cn } from '@virginexperiencedays/tailwind';

export const Section = forwardRef(
  (
    { children, className, ...rest }: HTMLAttributes<HTMLDivElement>,
    ref: RefObject<HTMLDivElement>
  ) => {
    return (
      <section
        ref={ref}
        className={cn(
          'border-border-neutral dark:border-persistent-text-light border-b border-solid pb-6 last:border-b-0 last:pb-0',
          className
        )}
        {...rest}
      >
        {children}
      </section>
    );
  }
);
Section.displayName = 'Section';
